import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import ProductOrderAttachmentResponse from "../../../model/productOrder/ProductOrderAttachmentResponse";
import { ProductOrderService } from "../../../service/productOrder/ProductOrderService";

class AttachmentsStore {
    public deliveryOrderId?: string;
    public attachments: ProductOrderAttachmentResponse[];
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, remittanceId?: string) {
        this.deliveryOrderId = remittanceId;
        this.isModalOpen = false;
        this.attachments = [];
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async loadMoneyDeliveryOrderAttachments() {
        const response = await ProductOrderService.getAttachments(this.deliveryOrderId!);
        if (response.success && response.data) {
            this.attachments = response.data;
        }
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        await this.loadMoneyDeliveryOrderAttachments();
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }
}

export default AttachmentsStore;